import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    const options = {
      plugins: ["remove_button"],
      placeholder: this.element.dataset.placeholder || "Select...",
      allowEmptyOption: true
    }

    if (this.element.dataset.create === "true") {
      options.create = true
      options.createOnBlur = true
      options.persist = false
    }

    this.tom = new TomSelect(this.element, options)
  }

  disconnect() {
    if (this.tom) this.tom.destroy()
  }
}
